import RequireAuth from "../components/routing/RequireAuth";

const protectRoute = (route) => {
  const protectedRoute = {
    ...route,
    element: <RequireAuth>{route.element}</RequireAuth>,
  };
  if (route.children) {
    protectedRoute.children = route.children.map(protectRoute);
  }
  return protectedRoute;
};

export const protectRoutes = (routes) => routes.map(protectRoute);
